import { Component} from '@angular/core'

@Component({
    selector: 'b4a-welcome-page',
    templateUrl: './welcome-page.html',
    styleUrls: ['welcome-page.css']
})

export class WeclomeComponent {

  constructor () {}

}



// WEBPACK FOOTER //
// ./src/app/welcome-page/welcome-page.ts